module.exports = __webpack_public_path__ + "static/media/4-广联达现场劳务管理系统.ff77ad04.png";